import React from "react";
import Optional from "./optional";
import Included from "./included";
import useInsurancePlus from "../../shared/hooks/useInsurancePlus";

export default function InsurancePlus(): React.JSX.Element {
  const { hasInsurancePlus } = useInsurancePlus();

  return <>{hasInsurancePlus ? <Included /> : <Optional />}</>;
}
